import React, { createContext, useState, useEffect, useRef } from "react";

export const GoogleTranslateContext = createContext();

const GoogleTranslateProvider = ({ children }) => {
  const [currentLanguage, setCurrentLanguage] = useState("en");
  const [isInitialized, setIsInitialized] = useState(false);
  const languageSelectorRef = useRef(null);

  // // Initialize Google Translate
  // useEffect(() => {
  //   // Clean up any existing elements to avoid conflicts
  //   const existingScript = document.getElementById("google-translate-script");
  //   if (existingScript) {
  //     existingScript.remove();
  //   }

  //   // Create hidden container for Google Translate
  //   let translateElement = document.getElementById("google_translate_element");
  //   if (!translateElement) {
  //     translateElement = document.createElement("div");
  //     translateElement.id = "google_translate_element";
  //     translateElement.style.display = "none";
  //     document.body.appendChild(translateElement);
  //   }

  //   // Add CSS to hide Google Translate elements
  //   const hideGoogleTranslateElements = () => {
  //     const style = document.createElement("style");
  //     style.id = "google-translate-hide-style";
  //     style.innerHTML = `
  //       .goog-te-banner-frame {
  //         display: none !important;
  //       }
  //       .goog-te-menu-value:hover {
  //         text-decoration: none !important;
  //       }
  //       body {
  //         top: 0 !important;
  //       }
  //       .skiptranslate {
  //         display: none !important;
  //       }

  //       /* Add a class to exclude elements from translation */
  //       .notranslate {
  //         /* This class prevents Google from translating the element */
  //       }
  //     `;
  //     document.head.appendChild(style);
  //   };

  //   // Define initialization function
  //   window.googleTranslateElementInit = function () {
  //     new window.google.translate.TranslateElement(
  //       {
  //         pageLanguage: "en",
  //         includedLanguages: "en,ar",
  //         autoDisplay: false,
  //         layout: window.google.translate.TranslateElement.InlineLayout.SIMPLE,
  //       },
  //       "google_translate_element"
  //     );

  //     // Hide Google Translate elements
  //     hideGoogleTranslateElements();

  //     // Wait for initialization
  //     setTimeout(() => {
  //       setIsInitialized(true);

  //       // If we have a non-default language already set, apply it
  //       if (currentLanguage !== "en") {
  //         doTranslate(currentLanguage);
  //       }

  //       // Add protection to language selector elements
  //       protectLanguageSelectors();
  //     }, 1000);
  //   };

  //   // Load the Google Translate script
  //   const script = document.createElement("script");
  //   script.id = "google-translate-script";
  //   script.src =
  //     "https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit";
  //   script.async = true;
  //   document.body.appendChild(script);

  //   // Clean up function
  //   return () => {
  //     window.googleTranslateElementInit = undefined;
  //     if (existingScript) document.body.appendChild(existingScript);
  //     const style = document.getElementById("google-translate-hide-style");
  //     if (style) style.remove();
  //   };
  // }, []);

  // // Function to protect language selector elements from translation
  // const protectLanguageSelectors = () => {
  //   // Get any custom language selector ref if provided
  //   if (languageSelectorRef.current) {
  //     languageSelectorRef.current.classList.add("notranslate");
  //   }

  //   // Also find other common language selector elements
  //   const possibleSelectors = [
  //     ".language-selector",
  //     ".lang-selector",
  //     'select[name="language"]',
  //     "[data-language-selector]",
  //     "#languageSelector",
  //   ];

  //   possibleSelectors.forEach((selector) => {
  //     const elements = document.querySelectorAll(selector);
  //     elements.forEach((el) => {
  //       el.classList.add("notranslate");
  //     });
  //   });
  // };

  // // Register a language selector to be protected from translation
  // const registerLanguageSelector = (ref) => {
  //   languageSelectorRef.current = ref;
  //   if (isInitialized && ref) {
  //     ref.classList.add("notranslate");
  //   }
  // };

  // // Core translation function
  // const doTranslate = (langCode) => {
  //   if (!window.google || !window.google.translate) {
  //     console.warn("Google Translate not yet initialized");
  //   }

  //   // Update internal state
  //   setCurrentLanguage(langCode);

  //   try {
  //     // Apply notranslate class to elements that should be protected
  //     protectLanguageSelectors();

  //     // Direct cookie manipulation
  //     document.cookie = `googtrans=/en/${langCode}`;
  //     localStorage.setItem("selectedLanguage", langCode);

  //     // Also set for potential subdomains
  //     const domain = window.location.hostname;
  //     document.cookie = `googtrans=/en/${langCode};domain=.${domain};path=/`;

  //     // Try to use the select element if it exists (for no page reload)
  //     const selectElement = document.querySelector(".goog-te-combo");
  //     if (selectElement) {
  //       selectElement.value = langCode;
  //       selectElement.dispatchEvent(new Event("change", { bubbles: true }));
  //       // document.documentElement.setAttribute(
  //       //   "dir",
  //       //   langCode === "ar" ? "rtl" : "ltr"
  //       // );
  //     } else {
  //       // If we can't find the select element, reload the page to apply cookie
  //       window.location.reload();
  //     }
  //   } catch (error) {
  //     console.error("Translation error:", error);
  //     window.location.reload();
  //   }
  // };

  // // Public method to change the language
  // const changeLanguage = (lang) => {
  //   doTranslate(lang);
  // };

  const changeLanguage = (lang) => {
    setCurrentLanguage(lang);
  };
  const registerLanguageSelector = (ref) => {};

  return (
    <GoogleTranslateContext.Provider
      value={{
        currentLanguage,
        changeLanguage,
        isInitialized,
        setCurrentLanguage,
        registerLanguageSelector,
      }}
    >
      {children}
    </GoogleTranslateContext.Provider>
  );
};

export default GoogleTranslateProvider;
